export default "__VITE_ASSET__BfVO72n___"